import { createRouter, createWebHistory } from 'vue-router'
// Меню ресторана — точка входа по QR-коду, поэтому в основном бандле.
import VendorViewNew from '@/views/VendorViewNew.vue'

// Остальные страницы грузятся при переходе на них.
const HomeView = () => import('@/views/HomeView.vue')
const VendorProductNew = () => import('@/views/VendorProductNew.vue')
const VendorAboutNew = () => import('@/views/VendorAboutNew.vue')
const VendorAuth = () => import('@/views/VendorAuth.vue')
const VendorReset = () => import('@/views/VendorReset.vue')
const VendorRegister = () => import('@/views/VendorRegister.vue')
const VendorProfile = () => import('@/views/VendorProfile.vue')
const VendorFeedback = () => import('@/views/VendorFeedback.vue')
const VendorRedirect = () => import('@/views/VendorRedirect.vue')
const VendorSlider = () => import('@/views/VendorSlider.vue')
const VendorCart = () => import('@/views/VendorCart.vue')
const VendorCheckout = () => import('@/views/VendorCheckout.vue')
const VendorLink = () => import('@/views/VendorLink.vue')
const PageNotFound = () => import('@/views/PageNotFound.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/:vendor',
    name: 'vendor',
    component: VendorViewNew
  },
  {
    path: '/:vendor/s',
    component: VendorRedirect
  },
  {
    path: '/:vendor/s/:slider',
    name: 'slider',
    component: VendorSlider
  },
  {
    path: '/:vendor/p',
    component: VendorRedirect
  },
  {
    path: '/:vendor/p/:product',
    name: 'product',
    component: VendorProductNew
  },
  {
    path: '/:vendor/about',
    name: 'about',
    component: VendorAboutNew
  },
  {
    path: '/:vendor/feedback',
    name: 'feedback',
    component: VendorFeedback
  },
  {
    path: '/:vendor/login',
    name: 'login',
    component: VendorAuth
  },
  {
    path: '/:vendor/reset',
    name: 'reset',
    component: VendorReset
  },
  {
    path: '/:vendor/register',
    name: 'register',
    component: VendorRegister
  },
  {
    path: '/:vendor/profile',
    name: 'profile',
    component: VendorProfile
  },
  {
    path: '/:vendor/cart',
    name: 'cart',
    component: VendorCart
  },
  {
    path: '/:vendor/checkout',
    name: 'checkout',
    component: VendorCheckout
  },
  {
    path: '/:vendor/link',
    name: 'link',
    component: VendorLink
  },
  {
    path: '/:vendor/new',
    name: 'vendor_new',
    component: VendorViewNew
  },
  {
    path: '/:vendor/new/p/:product',
    name: 'product_new',
    component: VendorProductNew
  },
  {
    path: '/:vendor/new/about',
    name: 'about_new',
    component: VendorAboutNew
  },
  { path: "/:vendor/:pathMatch(.*)*", name: 'page404', component: PageNotFound }
]



const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Страница открыта давно, а мы за это время выкатили новую версию: файла страницы
// со старым хэшем может уже не быть, и переход молча обрывался («кнопка не нажимается»).
// В этом случае перезагружаемся сразу на нужный адрес — получим свежую сборку.
// Защита от цикла: не чаще раза в 20 секунд.
const CHUNK_ERROR = /dynamically imported module|Importing a module script failed|module script|Loading chunk|Unable to preload/i
export function reloadForNewVersion(path) {
  const last = +sessionStorage.getItem('chunk_reload') || 0
  if (Date.now() - last < 20000) return false
  sessionStorage.setItem('chunk_reload', String(Date.now()))
  window.location.assign(path || window.location.href)
  return true
}
router.onError((err, to) => {
  if (!CHUNK_ERROR.test(String(err && err.message))) return
  if (reloadForNewVersion(to && to.fullPath)) return
  // уже перезагружались, а страница всё равно не грузится (Safari помнит неудачную
  // загрузку модуля) — вместо пустого экрана открываем меню: оно в основном бандле
  const vendor = to && to.params && to.params.vendor
  if (vendor && to.name !== 'vendor') router.replace({ name: 'vendor', params: { vendor } })
})

// Пока гость смотрит меню, подгружаем страницы, куда он перейдёт чаще всего:
// переходы станут мгновенными даже на медленном интернете.
export function prefetchGuestPages() {
  // ошибка предзагрузки не страшна: при переходе файл запросится снова
  const load = () => [VendorProductNew, VendorAboutNew, VendorCart].forEach(c => c().catch(() => {}))
  if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 4000 })
  else setTimeout(load, 2500)
}

export default router
